<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>verified</md-icon>
					</template>

					<template slot="content">
						<p class="category">ចំនួន Check-In សរុប</p>
						<h3 class="title">{{stat.total_check_in}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>groups</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនអតិថិជនសរុប</p>
						<h3 class="title">{{stat.total_client}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>domain</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនសាខាសរុប</p>
						<h3 class="title">{{stat.total_branch}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>card_membership</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនកញ្ចប់សេវាកម្មសរុប</p>
						<h3 class="title">{{stat.total_package}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>supervised_user_circle</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនអ្នកគ្រប់គ្រង</p>
						<h3 class="title">{{stat.total_admin}}</h3>
					</template>
				</stats-card>
			</div>

		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	import { Datetime } from 'vue-datetime';
	import {
		NewMember
	} from '@/pages/Dashboard/index'

	export default {
		components: {
			StatsCard,
			NewMember,
			Datetime
		},
		mounted() {
			// if (this.$store.state.authentication.account_type == 'ca') {
			// 	this.$router.push('/new_package');
			// }
		},
		created() {
			this.$http.get(this.config.api + "/admin/get/stat").then(data => {
				this.stat = data.body.data
				this.loaded = true;
			});
			// this.getToday();
			// this.getMonth();
		},
		methods: {
			getToday() {
				this.$http.get(this.config.api + "/admin/get/stat/day").then(data => {
					this.today = data.body.data
				});
			},
			getMonth() {
				this.$http.get(this.config.api + "/admin/get/stat/month").then(data => {
					this.month = data.body.data
				});
			},
			getRange() {
				let start_date = (new Date(this.start_date)).getTime();
				let end_date = (new Date(this.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/get/stat/range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data
					// this.loaded = true;
				});
			}
		},
		computed: {
		},
		data() {
			return {
				loaded: false,
				stat: {
					total_admin: 0,
					total_package: 0,
					total_driver: 0,
					total_client: 0,
					total_zone: 0,
					total_location: 0,
					total_package_type: 0,
					unpaid_referral: 0,
					unpaid_pickup_fee: 0,
					unpaid_driver_fee: 0,
					unpaid_client_khr: 0,
					unpaid_client_usd: 0,
					unpaid_fee_khr: 0,
					unpaid_fee_usd: 0
				},
				today: {
					total_pending_package: 0,
					total_package: 0,
					total_deposit_khr: 0,
					total_deposit_usd: 0,
					total_wit_usd: 0,
					total_wit_khr: 0,
					total_fee_usd: 0,
					total_fee_khr: 0,
					total_driver_fee_usd: 0,
					total_driver_fee_khr: 0
				},
				month: {
					total_pending_package: 0,
					total_package: 0,
					total_deposit_khr: 0,
					total_deposit_usd: 0,
					total_wit_usd: 0,
					total_wit_khr: 0,
					total_fee_usd: 0,
					total_fee_khr: 0,
					total_driver_fee_usd: 0,
					total_driver_fee_khr: 0
				},
				start_date: "",
				end_date: "",
				range: {
					total_pending_package: 0,
					total_package: 0,
					total_deposit_khr: 0,
					total_deposit_usd: 0,
					total_wit_usd: 0,
					total_wit_khr: 0,
					total_fee_usd: 0,
					total_fee_khr: 0,
					total_driver_fee_usd: 0,
					total_driver_fee_khr: 0
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue